<div class="container my-4" *ngIf="!detail">
  <h3 class="mb-3">Danh sách Phiếu Trả Hàng</h3>
  <div class="table-responsive">
    <table class="table table-bordered table-hover align-middle">
      <thead class="table-light">
        <tr>
          <th>Mã phiếu</th>
          <th>Lý do</th>
          <th>Trạng thái</th>
          <th>Ngày tạo</th>
          <th>Cập nhật</th>
          <th>Thao tác</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of returnOrders">
          <td>{{ row.code }}</td>
          <td>{{ row.reason }}</td>
          <td>
            <span class="badge" [ngClass]="getStatusClass(row.status)">
              {{ ReturnRequestStatusValue[row.status] }}
            </span>
          </td>
          <td>{{ row.createdAt | date:'short' }}</td>
          <td>{{ row.updatedAt | date:'short' }}</td>
          <td>
            <button class="btn btn-sm fw-bold text-light theme-bg-color" (click)="viewDetail(row)">
              Xem chi tiết
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div *ngIf="detail">
  <app-return-order-detail [request]="detail" [productMap]="productMap" ></app-return-order-detail>
  <div class="d-flex justify-content-end gap-3 mt-3 container">
    <button type="button" class="btn btn-sm btn-link border rounded" (click)="detail = undefined"><i class="ri-arrow-left-line"></i>&nbsp;Quay lại</button>
  </div>
</div>
